export const CHECKOUT_URL = 'https://guia.impultienda.ar/checkout/anticoagulacion'

export const MOCKUP_IMAGE =
  'https://cdn.magicpatterns.com/uploads/rmeTsw4F5E2cmBef3dmEue/ANTICOAGULACION.png'

export const BONUS_IMAGE =
  'https://cdn.magicpatterns.com/uploads/i4Udv4u21EErxzFb1yFG9v/BONO_1_ANTICOAGULACION.png'

export const DOCTOR_IMAGE =
  'https://cdn.magicpatterns.com/patterns/generated-images/f5a8c76a-1c29-43cc-9e22-c2fd9c7b58b7.jpg'

export const stats = [
  { value: '+1.200', label: 'Médicos ya deciden sin dudar' },
  { value: '6', label: 'Tomos maestros completos' },
  { value: '+300', label: 'Decisiones críticas resueltas' },
  { value: '99%', label: 'Lo recomienda' },
]

export const beforeItems = [
  'Minutos frente al paciente sin saber qué hacer',
  'Decisiones basadas en memoria o intuición',
  'Miedo constante a equivocarte',
  'Warfarina vs DOAC = duda constante',
  'Suspender antes de cirugía = riesgo de trombo o sangrado',
  'Sangrado activo = parálisis total',
  'Interacciones invisibles que comprometen el tratamiento',
  'Historia clínica débil ante auditorías',
]

export const afterItems = [
  'Decisión clara en menos de 60 segundos',
  'Un sistema que te indica exactamente qué hacer',
  'Seguridad clínica respaldada en cada paso',
  'Sabes exactamente cuál usar, cuándo y por qué',
  'Protocolo exacto, paso a paso, sin margen de error',
  'Actúas en segundos con dosis claras y definidas',
  'Detectas los riesgos antes de que ocurran',
  'Cada decisión queda respaldada y protegida',
]

export const painPoints = [
  { emoji: '😰', text: 'Tienes al paciente enfrente y piensas: “Si anticoagulo… ¿y si sangra?”' },
  { emoji: '⏱️', text: 'Estás en urgencias, el tiempo corre y aún no tienes una decisión clara' },
  { emoji: '🧠', text: 'Ya calculaste los scores y aun así no tienes certeza sobre qué hacer' },
  { emoji: '🔄', text: 'Hay una cirugía próxima y no sabes si suspender, puentear o continuar' },
  { emoji: '💊', text: 'La función renal es límite y no estás seguro si la dosis es adecuada' },
  { emoji: '⚖️', text: 'Sabes que si algo sale mal, esa decisión fue tuya' },
]

export const tomos = [
  {
    num: '01',
    emoji: '🧠',
    title: 'El Mapa de Decisión Sin Duda™',
    text: 'Cómo saber exactamente cuándo anticoagular, cuándo no… y por qué, en menos de 60 segundos. Pasas del “depende” a una decisión clara.',
  },
  {
    num: '02',
    emoji: '⚖️',
    title: 'La Fórmula de Anticoagulación Perfecta™',
    text: 'Eliges entre DOACs o Warfarina con seguridad, según el perfil del paciente. Sin improvisación.',
  },
  {
    num: '03',
    emoji: '⏱️',
    title: 'El Protocolo Cero Riesgo en Cirugía™',
    text: 'Suspender, puentear y reiniciar sin incertidumbre. Cada paso definido antes de la cirugía.',
  },
  {
    num: '04',
    emoji: '🚨',
    title: 'El Sistema de Respuesta Inmediata ante Sangrados™',
    text: 'Cuando surge una complicación, sabes exactamente qué hacer. Sin dudar. Sin improvisar.',
  },
  {
    num: '05',
    emoji: '🛡️',
    title: 'El Escudo Antifallas Terapéuticas™',
    text: 'Detectas errores antes de que ocurran. Proteges al paciente y tu decisión.',
  },
  {
    num: '06',
    emoji: '📑',
    title: 'El Blindaje Médico Total™',
    text: 'Cada decisión queda documentada, justificada y defendible. Mayor tranquilidad profesional en cada caso.',
  },
]

export const bonuses = [
  {
    num: 'Bono 1',
    emoji: '🧮',
    title: 'La Calculadora Clínica Instantánea™',
    text: 'Ajusta dosis en segundos sin cálculos complejos.',
    image:
      'https://cdn.magicpatterns.com/uploads/i4Udv4u21EErxzFb1yFG9v/BONO_1_ANTICOAGULACION.png',
  },
  {
    num: 'Bono 2',
    emoji: '🔄',
    title: 'El Protocolo de Transición Sin Riesgo™',
    text: 'Cambia tratamientos sin dejar al paciente desprotegido.',
    image:
      'https://cdn.magicpatterns.com/uploads/sGQg15TXxNqwpc6ZCB7c1U/BONO_2_ANTICOAGULACION.png',
  },
  {
    num: 'Bono 3',
    emoji: '🚨',
    title: 'El Protocolo SOS Anticoagulación™',
    text: 'Actúa con rapidez y precisión ante sangrados.',
    image:
      'https://cdn.magicpatterns.com/uploads/aTVkXeJKBkD3zyZpgKJKNc/BONO_3_ANTICOAGULACION.png',
  },
  {
    num: 'Bono 4',
    emoji: '🛡️',
    title: 'El Escudo de Interacciones Críticas™',
    text: 'Identifica riesgos antes de prescribir.',
    image:
      'https://cdn.magicpatterns.com/uploads/kiutFdnpMrTRvJUvS3KaUf/BONO_4_ANTICOAGULACION.png',
  },
  {
    num: 'Bono 5',
    emoji: '📑',
    title: 'El Kit de Protección Médico-Legal™',
    text: 'Documenta y protege cada decisión clínica.',
    image:
      'https://cdn.magicpatterns.com/uploads/1nmPzTBz66pNfAeLC39Xhm/BONO_5_ANTICOAGULACION.png',
  },
]

export const includedItems = [
  'Sistema completo Ruta Anticoagulación™',
  '6 Tomos Maestros con sistemas de decisión clínica',
  'Algoritmos visuales listos para usar en consulta',
  'Protocolos completos para escenarios críticos',
  'Guías de ajuste según perfil del paciente',
  'Sistema de respuesta ante emergencias',
  'Plantillas médico-legales listas para aplicar',
]

export const testimonials = [
  {
    name: 'María P.',
    role: 'Medicina Interna',
    text: 'Antes dudaba en pacientes complejos. Ahora tengo claridad en segundos.',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/750478db-0381-4e39-a5ed-d0a9b1846e9a.jpg',
  },
  {
    name: 'Javier R.',
    role: 'Médico General',
    text: 'El protocolo perioperatorio me ayudó en un caso real. Todo estaba definido.',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/9e92c929-2455-4536-b9af-74f046188764.jpg',
  },
  {
    name: 'Adriana L.',
    role: 'Urgencias',
    text: 'El kit médico-legal me dio mucha tranquilidad. Es una herramienta clave.',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/5d075c2f-dac0-473f-87df-40cfb9a07097.jpg',
  },
  {
    name: 'Carlos R.',
    role: 'Medicina Familiar',
    text: 'Ahora tomo decisiones con más seguridad y menos dependencia de derivaciones.',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/6f79ea26-05d8-4a60-97be-5ae2cec8727e.jpg',
  },
  {
    name: 'Lucía M.',
    role: 'Cardiología',
    text: 'El sistema de interacciones me ha evitado errores importantes.',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/377200d1-3f92-4587-b153-f5a77b659f7a.jpg',
  },
]

export const faqs = [
  {
    q: '¿Cómo recibo el material?',
    a: 'Recibirás acceso inmediato tras el pago. Todo en formato digital compatible con cualquier dispositivo.',
  },
  {
    q: '¿Está dirigido a médicos generales?',
    a: 'Sí. Está diseñado especialmente para profesionales que deben tomar decisiones sin apoyo inmediato de especialistas.',
  },
  {
    q: '¿El contenido está actualizado?',
    a: 'Sí. Basado en guías actuales (ESC, ACC/AHA, CHEST), adaptadas a uso práctico.',
  },
  { q: '¿Es un pago único?', a: 'Sí. No hay suscripciones ni cargos adicionales.' },
  {
    q: '¿Es útil para odontología?',
    a: 'Sí. Especialmente en el manejo perioperatorio de pacientes anticoagulados.',
  },
  {
    q: '¿Qué pasa si no me funciona?',
    a: 'Cuentas con 7 días de garantía para solicitar la devolución total.',
  },
]

export const purchaseNotifications = [
  { name: 'Dra. Valentina R.', place: 'Bogotá, Colombia' },
  { name: 'Dr. Andrés M.', place: 'Ciudad de México, México' },
  { name: 'Dra. Camila S.', place: 'Buenos Aires, Argentina' },
  { name: 'Dr. Julián P.', place: 'Lima, Perú' },
  { name: 'Dra. Fernanda G.', place: 'Santiago, Chile' },
  { name: 'Dr. Ricardo T.', place: 'Guayaquil, Ecuador' },
  { name: 'Dra. Paula N.', place: 'Montevideo, Uruguay' },
  { name: 'Dr. Miguel Á.', place: 'Madrid, España' },
  { name: 'Dra. Rocío H.', place: 'San José, Costa Rica' },
  { name: 'Dr. Esteban V.', place: 'Asunción, Paraguay' },
  { name: 'Dra. Daniela C.', place: 'Caracas, Venezuela' },
  { name: 'Dr. Óscar L.', place: 'Ciudad de Panamá, Panamá' },
]
